import { render, staticRenderFns } from "./ModalEditarDescricaoOpcaoEnquete.vue?vue&type=template&id=09ed031a&scoped=true"
import script from "./ModalEditarDescricaoOpcaoEnquete.vue?vue&type=script&lang=js"
export * from "./ModalEditarDescricaoOpcaoEnquete.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarDescricaoOpcaoEnquete.vue?vue&type=style&index=0&id=09ed031a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ed031a",
  null
  
)

export default component.exports